import { render, staticRenderFns } from "./AsignacionTurnoSection.vue?vue&type=template&id=0f34cb0b&scoped=true"
import script from "./AsignacionTurnoSection.vue?vue&type=script&lang=js"
export * from "./AsignacionTurnoSection.vue?vue&type=script&lang=js"
import style0 from "./AsignacionTurnoSection.vue?vue&type=style&index=0&id=0f34cb0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34cb0b",
  null
  
)

export default component.exports